













































import {
  Question,
  QuestionObjective,
} from '@/resource/question/question.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalAddQuestion from '@/components/modals/ModalAddQuestion.vue';
import ModalRegister from '@/components/modals/ModalRegister.vue';
import PublicQuestionInfo from '@/components/public-questions/PublicQuestionInfo.vue';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';
import { getToken } from '@/utils/cookie';
import { QuestionLanguage } from '@/resource/subject/subject.model';

@Component({
  components: {
    ModalAddQuestion,
    QuestionContainer,
    PublicQuestionInfo,
    ModalRegister,
  },
})
export default class PublicQuestionContainer extends Vue {
  @Prop({ required: true })
  question!: Question;

  @Prop({ required: true })
  isObjective!: boolean;

  @Prop({ required: true })
  languages!: QuestionLanguage[];

  showAddQuestion = false;
  showRegister = false;

  get answerPosition() {
    if (this.isObjective) {
      const objective = this.question as QuestionObjective;
      return objective.answers.findIndex(answer => {
        return answer.isCorrect;
      });
    } else {
      return 0;
    }
  }

  get isLoggedin() {
    return getToken() ? true : false;
  }

  get adminMode(): boolean {
    let adminMode = false;
    if (typeof this.$route.query['admin-mode'] === 'string') {
      const queryIsSubjective = this.$route.query['admin-mode'];

      if (queryIsSubjective) {
        if (queryIsSubjective.toLowerCase() === 'true') {
          adminMode = true;
        } else if (queryIsSubjective.toLowerCase() === 'false') {
          adminMode = false;
        }
      }
    }
    return adminMode;
  }

  addQuestionClicked() {
    if (this.isLoggedin) {
      this.showAddQuestion = true;
    } else {
      this.showRegister = true;
    }
  }

  closeAddQuestion() {
    this.showAddQuestion = false;
  }

  closeRegister() {
    this.showRegister = false;
  }

  toQuestionPreview() {
    return `/add-question?question-id=${this.question.id}&is-subjective=${!this
      .isObjective}`;
  }
}
